<template>
  <el-container>
    <el-aside width="200px">
      <side-bar></side-bar>
    </el-aside>
    <el-container>
      <el-header>
        <nav-header></nav-header>
      </el-header>
      <el-main>
        <div class="content">
          <keep-alive>
            <!-- <router-view v-if="$route.meta.keepAlive"></router-view> -->
            <!-- <router-view v-if="$route.meta.keepAlive"></router-view> -->
            <router-view
              v-if="$route.path === '/GoodsList' || $route.path === '/campusMicroStore' || $route.path === '/statisticalAnalysis' || $route.path === '/orderInformation'"></router-view>
          </keep-alive>
          <!-- <router-view v-if="!$route.meta.keepAlive"></router-view> -->
          <router-view v-if="!($route.path === '/GoodsList' || $route.path === '/campusMicroStore' || $route.path === '/statisticalAnalysis' || $route.path === '/orderInformation')"></router-view>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import NavHeader from "./NavHeader.vue";
import SideBar from "./SideBar.vue";
export default {
  data() {
    return {
      NavHeader,
      SideBar,
    };
  },
  components: { SideBar, NavHeader },
};
</script>

<style lang="scss" scoped>
.el-header {
  padding: 0;
  margin: 0;
}

.el-main {
  background-color: #e0e0e0;
  margin: 0;
  padding: 0;

  .content {
    margin: 10px;
    padding: 10px;
    background-color: #fff;
    border-radius: 10px;
    height: calc(100vh - 80px);
    overflow: auto;
  }
}</style>